import { cva as t } from "class-variance-authority";
const n = t(
  "",
  {
    variants: {
      variant: {
        default: "flex items-center justify-center gap-2 md:gap-4",
        primary: ""
      }
    }
  }
);
export {
  n as PaginationContentVariants
};
//# sourceMappingURL=PaginationContentVariants.mjs.map
